namespace TabAurous.Master {
    export interface TargetDistributionRow {
        TargetDistributionId?: number;
        Code?: string;
        January?: number;
        February?: number;
        March?: number;
        April?: number;
        May?: number;
        June?: number;
        July?: number;
        August?: number;
        September?: number;
        October?: number;
        November?: number;
        December?: number;
    }

    export namespace TargetDistributionRow {
        export const idProperty = 'TargetDistributionId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Master.TargetDistribution';
        export const lookupKey = 'Master.TargetDistribution';

        export function getLookup(): Q.Lookup<TargetDistributionRow> {
            return Q.getLookup<TargetDistributionRow>('Master.TargetDistribution');
        }
        export const deletePermission = 'HR:TargetDistribution:Delete';
        export const insertPermission = 'HR:TargetDistribution:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:TargetDistribution:Edit';

        export declare const enum Fields {
            TargetDistributionId = "TargetDistributionId",
            Code = "Code",
            January = "January",
            February = "February",
            March = "March",
            April = "April",
            May = "May",
            June = "June",
            July = "July",
            August = "August",
            September = "September",
            October = "October",
            November = "November",
            December = "December"
        }
    }
}
